import '@orestbida/iframemanager/dist/iframemanager.js'

const im = iframemanager()

im.run({
  currLang: 'de',

  services: {
    elfsight: {
      onAccept: async (div, setIframe) => {
        div.style.border = 0

        // Add Elfsight platform script
        const platformScript = document.createElement('script')
        platformScript.async = true
        platformScript.src = 'https://static.elfsight.com/platform/platform.js'
        document.body.appendChild(platformScript)

        // Add Elfsight app container
        const appDiv = document.createElement('div')
        appDiv.className = 'elfsight-app-89939fbd-2bea-40b2-8cdd-71ffc016ff21'
        appDiv.setAttribute('data-elfsight-app-lazy', '')
        div.appendChild(appDiv)
      },

      onReject: (iframe, div, showNotice) => {
        // Remove Elfsight container if exists
        const elfsightApp = document.querySelector(
          '.elfsight-app-89939fbd-2bea-40b2-8cdd-71ffc016ff21'
        )
        if (elfsightApp) {
          elfsightApp.remove()
        }

        // Remove Elfsight platform script if exists
        const platformScript = document.querySelector(
          'script[src="https://static.elfsight.com/platform/platform.js"]'
        )
        if (platformScript) {
          platformScript.remove()
        }

        // Clear container and show notice
        div.style.backgroundColor = ''
        showNotice()
      },
      languages: {
        de: {
          notice:
            'Dieser Inhalt wird von einem externen Anbieter gehostet. Durch die Anzeige des externen Inhalts akzeptieren Sie die Bedingungen und Konditionen von elfsight.',
          loadBtn: 'Laden',
          loadAllBtn: 'Nicht nochmal fragen',
        },
      },
    },
  },
})
